import PlaceholderPage from "../../../components/Placeholder/PlaceholderPage";

const VendorTagsPage = () => (
  <PlaceholderPage
    title="Tags"
    description="Vendor tags will be managed here."
  />
);

export default VendorTagsPage;
